exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.customer-card[data-v-ea358f62] {\n    width: -moz-max-content;\n    width: max-content;\n}\n", ""]);

// exports
